import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import AurProfilePicture from '../common/aur-profile-picture/AurProfilePicture';
import {UserData} from '../../types/concierge-reports/conciergeReportsType';

interface TeamMemberListProps {
  userList: UserData[];
  client: string;
}

interface TeamMemberRowProps {
  rowData: UserData;
  client: string;
}

const TeamMemberListHeader = (props: {userList: UserData[]}) => {
  return (
    <Box className="team-member-list-title">
      <Typography className="typo-text label2_size custom-label">
        {t('conciergeReports.uploadReports.teamMemberHeader', {
          teamMemberCount: props.userList.length,
        })}
      </Typography>
    </Box>
  );
};

const TeamMemberRow: React.FC<TeamMemberRowProps> = ({rowData, client}) => {
  return (
    <Box className="team-member-list-row">
      <Box>
        <AurProfilePicture
          bgColor={true}
          displayText={rowData.name
            .split(' ')
            .map((word) => word[0])
            .join('')
            .toUpperCase()}
          borderRadius={1}
          iconSize={32}
          textSize="Small"
          iconType="User"
        />
      </Box>
      <Box>
        <Typography className="typo-text body2_size custom-team-member-text">
          {rowData.name}
          {rowData?.isOwner
            ? t('conciergeReports.uploadReports.uploadedBy')
            : ''}
        </Typography>
        <Typography className="typo-text body3_size custom-project-name">
          {client}
        </Typography>
      </Box>
    </Box>
  );
};

const TeamMemberList: React.FC<TeamMemberListProps> = ({userList, client}) => {
  return (
    <Box className="team-member-list-main">
      <TeamMemberListHeader userList={userList} />
      {userList.map((userValue, index) => (
        <span key={index + 1}>
          <TeamMemberRow rowData={userValue} client={client} />
        </span>
      ))}
    </Box>
  );
};

export default TeamMemberList;
